import "./LoadingSpinner.css";

function LoadingSpinner({ fullScreen = false }) {
  return (
    <div className={`loading-container ${fullScreen ? "full" : ""}`}>
      <div className="spinner"></div>
    </div>
  );
}

export default LoadingSpinner;